const Company = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.25 7.25H12.85C13.6901 7.25 14.1101 7.25 14.431 7.41349C14.7132 7.5573 14.9427 7.78677 15.0865 8.06901C15.25 8.38988 15.25 8.80992 15.25 9.65V14.75M9.25 14.75V3.65C9.25 2.80992 9.25 2.38988 9.08651 2.06901C8.9427 1.78677 8.71323 1.5573 8.43099 1.41349C8.11012 1.25 7.69008 1.25 6.85 1.25H4.15C3.30992 1.25 2.88988 1.25 2.56901 1.41349C2.28677 1.5573 2.0573 1.78677 1.91349 2.06901C1.75 2.38988 1.75 2.80992 1.75 3.65V14.75M16 14.75H1M4.375 4.25H6.625M4.375 7.25H6.625M4.375 10.25H6.625"
      stroke="white"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Company;
